import { Grid, Paper, Table, TableBody, TableContainer, TableHead, TableRow } from "@mui/material";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SubscriberModel } from "../../../../Api/Models/SubscriberModel";
import DashboardLayout from "../../../../Components/LayoutContainers/DashboardLayout";
import MDBox from "../../../../Components/MDBox";
import MDDivider from "../../../../Components/MDDivider";
import MDInput from "../../../../Components/MDInput";
import AppLoading from "../../../../Components/MDLoading";
import MDTableCell from "../../../../Components/MDTable/MDTableCell";
import MDTableRow from "../../../../Components/MDTable/MDTableRow";
import MDTypography from "../../../../Components/MDTypography";
import DashboardNavbar from "../../../../Components/Navbars/DashboardNavbar";
import { SubscribeDetailDto } from "../../../../Types/Api/DTO/SubscriberDto";
import { v4 as uuid } from "uuid";
export default function SubscribersDetail() {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const [data, setData] = useState<SubscribeDetailDto | null>(null);
  const [loading, setLoading] = useState(true);
  let subscriberModel = new SubscriberModel();

  const navigate = useNavigate();
  let Id = params.get("Id");

  useEffect(() => {
    if (Id !== null && Id !== "") {
      subscriberModel
        .get(parseInt(Id))
        .then((r) => {
          setData(r.data.data as SubscribeDetailDto);
          setLoading(false);
        })
        .catch((r) => {
          setLoading(false);
        });
    }
    return () => {
      subscriberModel.baseApi.handleCancelRequest();
    };
  }, []);
  if (Id === null || Id === "") {
    navigate("notfound", { replace: true });
    return null;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar name={"جزئیات مشترک"} />
      <MDBox py={3} bgColor="white" p={2} mb={2} borderRadius={2}>
        <MDTypography fontSize={14}>{t("جزئیات")}</MDTypography>
        <Grid container mb={2}>
          <Grid item container xs={12} md={6} lg={6} alignItems="center">
            <Grid item xs={2} textAlign="center">
              <MDTypography fontSize={14}>کد اشتراک</MDTypography>
            </Grid>
            <Grid item xs={8} my={1}>
              <MDInput
                size={"small"}
                name="کد اشتراک"
                label={"کد اشتراک"}
                fullWidth
                disabled
                value={data?.subscriber ?? ""}
                focused
                autoComplete="off"
                onChange={() => {}}
              />
            </Grid>
          </Grid>
          <Grid item container xs={12} md={6} lg={6} alignItems="center">
            <Grid item xs={2} textAlign="center">
              <MDTypography fontSize={14}>قالب قبض</MDTypography>
            </Grid>
            <Grid item xs={8} my={1}>
              <MDInput
                size={"small"}
                name="قالب قبض"
                label={"قالب قبض"}
                fullWidth
                disabled
                value={data?.ghabzAvarezName ?? ""}
                focused
                autoComplete="off"
                onChange={() => {}}
              />
            </Grid>
          </Grid>
          <Grid item container xs={12} md={6} lg={6} alignItems="center">
            <Grid item xs={2} textAlign="center">
              <MDTypography fontSize={14}>فرمول قبض</MDTypography>
            </Grid>
            <Grid item xs={8} my={1}>
              <MDInput
                size={"small"}
                name="فرمول قبض"
                label={"فرمول قبض"}
                fullWidth
                disabled
                value={data?.ghabzFormula ?? ""}
                focused
                autoComplete="off"
                onChange={() => {}}
              />
            </Grid>
          </Grid>
          <Grid item container xs={12} md={6} lg={6} alignItems="center">
            <Grid item xs={2} textAlign="center">
              <MDTypography fontSize={14}>جمع نهایی</MDTypography>
            </Grid>
            <Grid item xs={8} my={1}>
              <MDInput
                size={"small"}
                name="جمع نهایی"
                label={"جمع نهایی"}
                fullWidth
                disabled
                value={data?.totalAmount ?? ""}
                focused
                autoComplete="off"
                onChange={() => {}}
              />
            </Grid>
          </Grid>
        </Grid>
        <MDDivider />
      </MDBox>
      <MDBox py={3} bgColor="white" p={2} mb={2} borderRadius={2}>
        <MDTypography fontSize={14}>پارامتر های قبض</MDTypography>
        <MDBox display="flex" sx={{ justifyContent: "center" }}>
          <TableContainer component={Paper} sx={{ marginTop: 2, width: "50%" }}>
            <Table aria-label="customized table">
              <TableHead>
                <TableRow>
                  <MDTableCell align={"center"} style={{ minWidth: 170 }}>
                    شماره اشتراک
                  </MDTableCell>
                  <MDTableCell align={"center"} style={{ minWidth: 170 }}>
                    مبلغ کل
                  </MDTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.subscribeRows && data?.subscribeRows?.length < 1 && (
                  <MDTableRow
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <MDTableCell colSpan={6} align="right">
                      هیچ ردیفی وجود ندارد
                    </MDTableCell>
                  </MDTableRow>
                )}
                {data?.subscribeRows &&
                  data?.subscribeRows.map((e) => {
                    return (
                      <MDTableRow hover role="checkbox" tabIndex={-1} key={uuid()}>
                        <MDTableCell align={"center"}>{e.fieldName}</MDTableCell>
                        <MDTableCell align={"center"}>{e.value}</MDTableCell>
                      </MDTableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </MDBox>
      </MDBox>

      <AppLoading show={loading} />
    </DashboardLayout>
  );
}
